import { MouseEvent } from 'react';
import CloseIcon from '../icons/CloseIcon';

interface ISavedIconsPopup {
    setPopupShown: Function
}

const CategoriesPopup = (props: ISavedIconsPopup) => {

    const close = () => {
        props.setPopupShown(false);
    };

    const prevent = (evt: MouseEvent) => {
        evt.stopPropagation();
    };

    return (
        <div
            className="fixed bg-black/75 w-screen h-screen left-0 top-0 z-50 flex items-center justify-center"
            onClick={ close }>

            <div
                className="bg-white text-gray-900 rounded-xl relative"
                style={{
                    width: '390px',
                    maxWidth: '95%',
                }}
                onClick={ prevent }>

                <button
                    type="button"
                    className="cursor-pointer absolute right-2 top-2"
                    onClick={ close }>
                    <CloseIcon />
                </button>

                <div className="p-10">
                    <p className="text-2xl mb-4">How to use?</p>

                    <p className="mb-2 text-cyan-700"><b>Category filters:</b></p>
                    <ul className="text-lg list-disc ml-2 pl-2 mb-2">
                        <li>Select any category filter.</li>
                        <li>Click on <b>randomize</b> button below.</li>
                    </ul>

                    <p className="mb-4">Any new random icon will be selected from the chosen category.</p>

                    <p className="mb-4 text-xl text-gray-400"><i>OR</i></p>

                    <p className="mb-2 text-cyan-700"><b>Search icon:</b></p>
                    <ul className="text-lg list-disc ml-2 pl-2 mb-4">
                        <li>Click on <b>Search Icon</b> button below.</li>
                        <li>Search for an icon in the text field.</li>
                    </ul>

                    <div>
                        <button type="button" className="bg-sky-700 text-gray-100 px-16 py-2 rounded-full" onClick={ close }>OK</button>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default CategoriesPopup;